export default {
  // Login
  'login.title': 'Admin Login',
  'login.subtitle': 'Please login with your admin account, assigned by the super admin',
  'login.email': 'Username / Email',
  'login.emailPlaceholder': 'Enter your username or email',
  'login.password': 'Password',
  'login.passwordPlaceholder': 'Enter your password',
  'login.submit': 'Login',
  'login.loading': 'Logging in...',
  'login.failed': 'Login failed',
  'login.networkError': 'Network error',
  'login.unknownError': 'Unknown error',
  'login.emptyFields': 'Please enter username and password',
  'login.showPassword': 'Show password',
  'login.hidePassword': 'Hide password',
  'login.noSelfRegister': 'This platform does not offer self-registration. Please contact your super admin for account setup.',
  'login.footerText': 'Multi-tenant Management Platform',
  'login.brandTitle1': 'Multi-tenant',
  'login.brandTitle2': 'Console',
  'login.brandSlogan': 'Unified management of tenants, users, resources and billing policies for more efficient and secure enterprise operations.',
  'login.feature1Title': 'Access Control',
  'login.feature1Desc': 'Enterprise-grade access control and audit logs',
  'login.feature2Title': 'Data Isolation',
  'login.feature2Desc': 'Multi-tenant data isolation and quota management',
  'login.feature3Title': 'Monitoring',
  'login.feature3Desc': 'Real-time monitoring dashboards and analytics',

  // Sidebar
  'sidebar.home': 'Dashboard',
  'sidebar.users': 'Users & Permissions',
  'sidebar.resources': 'Features & Resources',
  'sidebar.tenants': 'Tenant Management',
  'sidebar.audit': 'Audit Logs',
  'sidebar.reports': 'Reports',
  'sidebar.settings': 'Settings',
  'sidebar.plans': 'Plan Management',
  'sidebar.waitlist': 'Waitlist',
  'sidebar.admin': 'System Admin',

  // Header
  'header.search': 'Search tenants, users, resources...',
  'header.notifications': 'Notifications',
  'header.viewAll': 'View all notifications',
  'header.profile': 'Profile',
  'header.settings': 'Settings',
  'header.logout': 'Logout',
  'header.notif.newTenant': 'New Tenant Registration',
  'header.notif.newTenantMsg': 'Tech Innovation Ltd. has registered',
  'header.notif.apiWarning': 'API Usage Warning',
  'header.notif.apiWarningMsg': 'Tenant T002 approaching quota limit',
  'header.notif.systemUpdate': 'System Update',
  'header.notif.systemUpdateMsg': 'System maintenance tonight',
  'header.notif.5minAgo': '5 min ago',
  'header.notif.1hourAgo': '1 hour ago',
  'header.notif.3hoursAgo': '3 hours ago',

  // Home
  'home.title': 'Dashboard',
  'home.subtitle': 'Welcome back, here is your multi-tenant management platform',
  'home.totalTenants': 'Total Tenants',
  'home.totalUsers': 'Total Users',
  'home.apiCalls': 'API Calls',
  'home.totalRevenue': 'Total Revenue',
  'home.totalSkills': 'Total Skills',
  'home.chatSessions': 'Chat Sessions',
  'home.totalMessages': 'Total Messages',
  'home.systemHealth': 'System Health',
  'home.active': 'active',
  'home.activeShort': 'active',
  'home.thisMonth': 'This month',
  'home.published': 'published',
  'home.cumulative': 'Cumulative',
  'home.running': 'Running normally',
  'home.vsLastMonth': 'vs last month',
  'home.apiTrend': 'API Usage Trend',
  'home.revenueTrend': 'Revenue Trend',
  'home.quickAccess': 'Quick Access',
  'home.recentActivity': 'Recent Activity',
  'home.viewAll': 'View all',
  'home.tenantDistribution': 'Tenant Distribution',
  'home.success': 'Success',
  'home.failed': 'Failed',
  'home.todayNewUsers': 'Today New Users',
  'home.todayNewUsersDesc': 'Users registered today',

  // Tenants
  'tenants.title': 'Tenant Management',
  'tenants.subtitle': 'Manage tenant configuration, quotas and billing policies',
  'tenants.export': 'Export List',
  'tenants.create': 'New Tenant',
  'tenants.total': 'Total',
  'tenants.unit': 'tenants',
  'tenants.clickTip': 'Click a row to view details',
  'tenants.showing': 'Showing',
  'tenants.to': '-',
  'tenants.of': 'of',
  'tenants.records': 'records',
  'tenants.createTitle': 'New Tenant',
  'tenants.createSuccess': 'Tenant created successfully!',
  'tenants.createFailed': 'Creation failed',
  'tenants.tenantName': 'Tenant Name',
  'tenants.subdomain': 'Subdomain',
  'tenants.contactName': 'Contact Name',
  'tenants.contactEmail': 'Contact Email',
  'tenants.planType': 'Plan Type',
  'tenants.deployRegion': 'Deploy Region',
  'tenants.cancel': 'Cancel',
  'tenants.createBtn': 'Create Tenant',
  'tenants.namePlaceholder': 'e.g. Tech Innovation Ltd.',
  'tenants.domainPlaceholder': 'techcorp',
  'tenants.contactPlaceholder': 'John Doe',
  'tenants.emailPlaceholder': 'admin@company.com',
  'tenants.plan.basic': 'Basic',
  'tenants.plan.professional': 'Professional',
  'tenants.plan.enterprise': 'Enterprise',
  'tenants.region.global': 'Global',
  'tenants.region.east': 'East China',
  'tenants.region.north': 'North China',
  'tenants.region.south': 'South China',
  'tenants.region.west': 'West China',
  'tenants.status.active': 'Active',
  'tenants.status.suspended': 'Suspended',
  'tenants.status.inactive': 'Inactive',
  'tenants.confirmDelete': 'Are you sure you want to delete this tenant? This action cannot be undone.',
  'tenants.loading': 'Loading...',
  'tenants.modal.name': 'Tenant Name',
  'tenants.modal.namePlaceholder': 'Enter tenant name',
  'tenants.modal.status': 'Status',
  'tenants.modal.region': 'Region',
  'tenants.modal.cancel': 'Cancel',
  'tenants.modal.save': 'Save',
  'tenants.modal.saving': 'Saving...',
  'tenants.modal.createTitle': 'New Tenant',
  'tenants.modal.editTitle': 'Edit Tenant',

  // Tenant Stats
  'tenantStats.total': 'Total Tenants',
  'tenantStats.inactive': 'Inactive Tenants',
  'tenantStats.active': 'Active Tenants',
  'tenantStats.totalUsers': 'Total Users',
  'tenantStats.monthlyRevenue': 'Monthly Revenue',

  // Tenant Filters
  'tenantFilters.searchTenant': 'Search tenant name...',
  'tenantFilters.search': 'Search tenant name, domain or contact...',
  'tenantFilters.inactive': 'Inactive',
  'tenantFilters.allPlans': 'All Plans',
  'tenantFilters.allStatus': 'All Status',
  'tenantFilters.active': 'Active',
  'tenantFilters.suspended': 'Suspended',
  'tenantFilters.trial': 'Trial',

  // Tenant Table
  'tenantTable.info': 'Tenant Info',
  'tenantTable.plan': 'Plan',
  'tenantTable.status': 'Status',
  'tenantTable.users': 'Users',
  'tenantTable.apiCalls': 'API Calls',
  'tenantTable.storage': 'Storage',
  'tenantTable.region': 'Region',
  'tenantTable.lastActive': 'Last Active',
  'tenantTable.actions': 'Actions',
  'tenantTable.viewDetail': 'View details',
  'tenantTable.edit': 'Edit',
  'tenantTable.delete': 'Delete',
  'tenantTable.createdAt': 'Created At',
  'tenantTable.more': 'More actions',
  'tenantTable.noMatch': 'No matching tenants',

  // Tenant Detail
  'tenantDetail.basicInfo': 'Basic Info',
  'tenantDetail.actions': 'Actions',
  'tenantDetail.editTenant': 'Edit Tenant',
  'tenantDetail.viewUsers': 'View Users',
  'tenantDetail.overview': 'Overview',
  'tenantDetail.quotaMgmt': 'Quota Management',
  'tenantDetail.dataIsolation': 'Data Isolation',
  'tenantDetail.billing': 'Billing',
  'tenantDetail.createdAt': 'Created at',
  'tenantDetail.resourceUsage': 'Resource Usage',
  'tenantDetail.apiCallUsage': 'API Calls',
  'tenantDetail.storageUsage': 'Storage',
  'tenantDetail.userCount': 'User Count',
  'tenantDetail.contactInfo': 'Contact Info',
  'tenantDetail.contact': 'Contact',
  'tenantDetail.email': 'Email',
  'tenantDetail.deployRegion': 'Deploy Region',
  'tenantDetail.lastActive': 'Last Active',
  'tenantDetail.enabledFeatures': 'Enabled Features',
  'tenantDetail.tags': 'Tenant Tags',
  'tenantDetail.quickActions': 'Quick Actions',
  'tenantDetail.suspend': 'Suspend Tenant',
  'tenantDetail.resume': 'Resume Tenant',
  'tenantDetail.sendNotice': 'Send Notification',
  'tenantDetail.simulateLogin': 'Simulate Login',
  'tenantDetail.exportData': 'Export Data',
  'tenantDetail.quotaSaved': 'Quota saved',
  'tenantDetail.quotaSettings': 'Quota Settings',
  'tenantDetail.quotaDesc': 'Adjust resource usage limits for this tenant',
  'tenantDetail.maxUsers': 'Max Users',
  'tenantDetail.apiCallsMonth': 'API Calls / Month',
  'tenantDetail.storageSpace': 'Storage',
  'tenantDetail.currentUsage': 'Current usage',
  'tenantDetail.saveQuota': 'Save Quota Settings',
  'tenantDetail.isolationSaved': 'Isolation policy saved',
  'tenantDetail.isolationPolicy': 'Data Isolation Policy',
  'tenantDetail.isolationDesc': 'Choose data storage and isolation method for this tenant',
  'tenantDetail.dedicated': 'Dedicated Isolation',
  'tenantDetail.dedicatedDesc': 'Allocate a dedicated database instance for this tenant with full data isolation, highest security, suitable for enterprise customers',
  'tenantDetail.shared': 'Shared Isolation',
  'tenantDetail.sharedDesc': 'Share database instance with other tenants, isolate data through row-level security policies, lower cost',
  'tenantDetail.recommended': 'Recommended',
  'tenantDetail.permissionConfig': 'Permission Configuration',
  'tenantDetail.crossTenantAccess': 'Cross-tenant Data Access',
  'tenantDetail.crossTenantDesc': 'Allow this tenant to access public data from other tenants',
  'tenantDetail.apiRateLimit': 'API Rate Limiting',
  'tenantDetail.apiRateLimitDesc': 'Apply rate limits to API requests from this tenant',
  'tenantDetail.dataExport': 'Data Export Permission',
  'tenantDetail.dataExportDesc': 'Allow this tenant to export its data',
  'tenantDetail.auditAccess': 'Audit Log Access',
  'tenantDetail.auditAccessDesc': 'Allow this tenant to view its own audit logs',
  'tenantDetail.saveIsolation': 'Save Isolation Policy',
  'tenantDetail.currentPlan': 'Current Plan Fee',
  'tenantDetail.perMonth': '/ month',
  'tenantDetail.nextBilling': 'Next billing date',
  'tenantDetail.billDetail': 'Bill Details',
  'tenantDetail.baseFee': 'Base Plan Fee',
  'tenantDetail.apiCallFee': 'API Call Fee',
  'tenantDetail.storageFee': 'Storage Fee',
  'tenantDetail.supportFee': 'Technical Support Fee',
  'tenantDetail.total': 'Total',
  'tenantDetail.historyBills': 'Billing History',
  'tenantDetail.paid': 'Paid',
  'tenantDetail.download': 'Download',
  'tenantDetail.feature.aiModels': 'AI Models',
  'tenantDetail.feature.apiAccess': 'API Access',
  'tenantDetail.feature.advancedAnalytics': 'Advanced Analytics',
  'tenantDetail.feature.basicAnalytics': 'Basic Analytics',
  'tenantDetail.feature.customDomain': 'Custom Domain',
  'tenantDetail.feature.sso': 'SSO Single Sign-On',
  'tenantDetail.feature.whiteLabel': 'White Label',

  // Users
  'users.title': 'Users & Permissions',
  'users.subtitle': 'Manage user accounts and permission settings for all tenants',
  'users.addUser': 'Add User',
  'users.totalUsers': 'Total Users',
  'users.activeUsers': 'Active Users',
  'users.admins': 'Admins',
  'users.developers': 'Developers',
  'users.loading': 'Loading...',
  'users.confirmDelete': 'Are you sure you want to delete this user?',
  'users.role.user': 'User',
  'users.role.admin': 'Admin',
  'users.role.developer': 'Developer',
  'users.status.active': 'Active',
  'users.status.inactive': 'Inactive',
  'users.status.suspended': 'Suspended',
  'users.status.banned': 'Banned',
  'users.modal.name': 'Name',
  'users.modal.email': 'Email',
  'users.modal.password': 'Password',
  'users.modal.passwordEditHint': ' (leave blank to keep unchanged)',
  'users.modal.passwordEditPlaceholder': 'Leave blank to keep unchanged',
  'users.modal.passwordPlaceholder': 'Set password',
  'users.modal.role': 'Role',
  'users.modal.status': 'Status',
  'users.modal.tenant': 'Organization',
  'users.modal.cancel': 'Cancel',
  'users.modal.save': 'Save',
  'users.modal.saving': 'Saving...',
  'users.modal.editTitle': 'Edit User',
  'users.modal.addTitle': 'Add User',

  // User Filters
  'userFilters.search': 'Search username, email or tenant...',
  'userFilters.allRoles': 'All Roles',
  'userFilters.admin': 'Admin',
  'userFilters.user': 'User',
  'userFilters.developer': 'Developer',
  'userFilters.allStatus': 'All Status',
  'userFilters.active': 'Active',
  'userFilters.inactive': 'Inactive',
  'userFilters.suspended': 'Suspended',
  'userFilters.banned': 'Banned',
  'userFilters.moreFilters': 'More Filters',

  // User Table
  'userTable.user': 'User',
  'userTable.tenant': 'Tenant',
  'userTable.role': 'Role',
  'userTable.status': 'Status',
  'userTable.lastLogin': 'Last Login',
  'userTable.actions': 'Actions',
  'userTable.role.admin': 'Admin',
  'userTable.role.user': 'User',
  'userTable.role.developer': 'Developer',
  'userTable.status.active': 'Active',
  'userTable.status.inactive': 'Inactive',
  'userTable.status.suspended': 'Suspended',
  'userTable.status.banned': 'Banned',
  'userTable.edit': 'Edit',
  'userTable.delete': 'Delete',
  'userTable.noData': 'No user data',

  // Resources
  'resources.title': 'Service Configs',
  'resources.subtitle': 'Manage AI models, API keys, and third-party service integrations',
  'resources.refresh': 'Refresh',
  'resources.addConfig': 'Add Config',
  'resources.totalConfigs': 'Total Configs',
  'resources.active': 'Active',
  'resources.categories': 'Categories',
  'resources.secrets': 'Secrets',
  'resources.addTitle': 'Add New Config',
  'resources.category': 'Category',
  'resources.configKey': 'Config Key',
  'resources.displayName': 'Display Name',
  'resources.value': 'Value',
  'resources.description': 'Description',
  'resources.secretValue': 'Secret value',
  'resources.type': 'Type:',
  'resources.save': 'Save',
  'resources.cancel': 'Cancel',
  'resources.create': 'Create',
  'resources.configs': 'configs',
  'resources.items': 'items',
  'resources.notConfigured': 'Not Configured',
  'resources.noConfigs': 'No configs found',
  'resources.running': 'Running',
  'resources.maintenance': 'Maintenance',
  'resources.endpoint': 'Endpoint',
  'resources.usageTenants': 'Using Tenants',
  'resources.usageUnit': '',
  'resources.usage': 'Usage',
  'resources.configure': 'Configure',
  'resources.stats': 'Stats',
  'resources.modelType': 'Type',
  'resources.version': 'Version',
  'resources.callCount': 'Call Count',
  'resources.cost': 'Cost',
  'resources.apiKey': 'API Key',
  'resources.edit': 'Edit',
  'resources.usageStats': 'Usage Stats',

  // Settings
  'settings.title': 'System Settings',
  'settings.subtitle': 'Manage global configuration, security policies and localization',
  'settings.tab.general': 'General',
  'settings.tab.services': 'Services',
  'settings.tab.security': 'Security',
  'settings.tab.notification': 'Notifications',
  'settings.tab.billing': 'Billing Plans',
  'settings.tab.locale': 'Languages',
  'settings.tab.registration': 'Registration',
  'settings.tab.points': 'Points Rules',
  'settings.systemInfo': 'System Info',
  'settings.version': 'Version',
  'settings.environment': 'Environment',
  'settings.production': 'Production',
  'settings.availability': 'Availability',
  'settings.lastBackup': 'Last Backup',
  'settings.todayAt': 'Today 03:00',

  // General Settings
  'general.platformInfo': 'Platform Information',
  'general.platformName': 'Platform Name',
  'general.platformUrl': 'Platform URL',
  'general.supportEmail': 'Support Email',
  'general.timezone': 'Timezone',
  'general.dateFormat': 'Date Format',
  'general.maxTenants': 'Max Tenants / Plan',
  'general.sessionMaintenance': 'Session & Maintenance',
  'general.sessionTimeout': 'Session Timeout',
  'general.sessionTimeoutDesc': 'Auto logout after user inactivity',
  'general.minutes': 'minutes',
  'general.maintenanceMode': 'Maintenance Mode',
  'general.maintenanceDesc': 'Frontend users will see a maintenance page when enabled',
  'general.maintenanceWarning': 'Maintenance mode is ON. All frontend users cannot access the platform. Please proceed with caution.',
  'general.reset': 'Reset',
  'general.save': 'Save Settings',
  'general.saved': 'Saved',

  // Security Settings
  'security.authPolicy': 'Authentication Policy',
  'security.mfa': 'Enforce Multi-Factor Authentication (MFA)',
  'security.mfaDesc': 'All admin accounts must enable MFA',
  'security.sso': 'SSO Single Sign-On',
  'security.ssoProtocol': 'Current protocol',
  'security.passwordPolicy': 'Password Policy',
  'security.minLength': 'Minimum Password Length',
  'security.chars': 'characters',
  'security.expireDays': 'Password Expiry',
  'security.days': 'days',
  'security.maxAttempts': 'Max Login Attempts',
  'security.times': 'times',
  'security.lockoutDuration': 'Account Lockout Duration',
  'security.ipWhitelist': 'IP Whitelist',
  'security.ipPlaceholder': 'Enter IP or CIDR, e.g. 192.168.1.0/24',
  'security.add': 'Add',
  'security.ipWhitelistDesc': 'When enabled, only whitelisted IP addresses can access the admin panel.',
  'security.auditLog': 'Audit Log',
  'security.retentionDays': 'Log Retention Days',
  'security.retentionDesc': 'Logs older than the retention period will be automatically cleaned',
  'security.reset': 'Reset',
  'security.save': 'Save Settings',
  'security.saved': 'Saved',

  // Notification Settings
  'notification.channels': 'Notification Channels',
  'notification.email': 'Email Notifications',
  'notification.emailDesc': 'Send system alerts and reports via email',
  'notification.sms': 'SMS Notifications',
  'notification.smsDesc': 'Send urgent alerts via SMS',
  'notification.webhook': 'Webhook Push',
  'notification.webhookDesc': 'Push events to a specified URL',
  'notification.webhookUrl': 'Webhook URL',
  'notification.alertEvents': 'Alert Events',
  'notification.tenantCreate': 'New Tenant Registration',
  'notification.tenantCreateDesc': 'Notify when a new tenant completes registration',
  'notification.quotaExceed': 'Quota Exceeded Alert',
  'notification.quotaExceedDesc': 'Notify when tenant API usage exceeds 90%',
  'notification.loginFail': 'Login Failure Alert',
  'notification.loginFailDesc': 'Notify when consecutive login failures reach threshold',
  'notification.systemError': 'System Error Alert',
  'notification.systemErrorDesc': 'Notify immediately when a critical system error occurs',
  'notification.scheduledReport': 'Scheduled Reports',
  'notification.dailyReport': 'Daily Report',
  'notification.dailyReportDesc': 'Send daily operational data summary',
  'notification.sendTime': 'Send Time',
  'notification.recipients': 'Report Recipients',
  'notification.emailPlaceholder': 'Enter email address',
  'notification.addBtn': 'Add',
  'notification.reset': 'Reset',
  'notification.save': 'Save Settings',
  'notification.saved': 'Saved',

  // Billing Plans
  'billing.saved': 'Plan saved',
  'billing.totalPlans': 'Total Plans',
  'billing.activePlans': 'Active Plans',
  'billing.highestPrice': 'Highest Price',
  'billing.editing': 'Editing',
  'billing.cancel': 'Cancel',
  'billing.save': 'Save',
  'billing.planName': 'Plan Name',
  'billing.monthlyFee': 'Monthly Fee (CNY)',
  'billing.apiCallsMonth': 'API Calls / Month',
  'billing.storageSpace': 'Storage (GB)',
  'billing.maxUsers': 'Max Users',
  'billing.supportType': 'Support Type',
  'billing.disabled': 'Disabled',
  'billing.perMonth': '/ month',
  'billing.edit': 'Edit',
  'billing.apiLabel': 'API Calls',
  'billing.storageLabel': 'Storage',
  'billing.usersLabel': 'Users',
  'billing.supportLabel': 'Support',

  // Locale Settings
  'locale.defaultLang': 'Default Language Settings',
  'locale.platformDefault': 'Platform Default Language',
  'locale.platformDefaultDesc': 'This language is used when a new user visits for the first time',
  'locale.fallbackLang': 'Fallback Language',
  'locale.fallbackLangDesc': 'Used when translation is missing',
  'locale.autoDetect': 'Auto-detect Browser Language',
  'locale.autoDetectDesc': 'Automatically switch language based on user browser settings',
  'locale.tenantOverride': 'Allow Tenant Language Override',
  'locale.tenantOverrideDesc': 'Tenants can override the platform default language in their settings',
  'locale.langManagement': 'Language Pack Management',
  'locale.enabled': 'enabled',
  'locale.default': 'Default',
  'locale.translationCoverage': 'Translation Coverage',
  'locale.cannotDisable': 'Default language cannot be disabled',
  'locale.coverageNote': 'Translation Coverage Note',
  'locale.coverageDesc': 'Language packs with coverage below 80% may show some UI elements in the fallback language. It is recommended to enable them publicly only after reaching 90% coverage.',
  'locale.save': 'Save Settings',
  'locale.saved': 'Saved',

  // Service Configs (Settings tab)
  'serviceConfigs.title': 'Service Configs',
  'serviceConfigs.subtitle': 'Manage AI models, third-party API keys, and external service integrations',
  'serviceConfigs.refresh': 'Refresh',

  // Audit
  'audit.title': 'Audit Logs',
  'audit.subtitle': 'System operation records and security audit',
  'audit.totalLogs': 'Total Logs',
  'audit.totalLogsDesc': 'All operation records',
  'audit.successOps': 'Successful Operations',
  'audit.successRate': 'Success rate',
  'audit.failedOps': 'Failed Operations',
  'audit.failedDesc': 'Needs attention',
  'audit.todayOps': 'Today\'s Operations',
  'audit.todayDesc': 'Today\'s activity',
  'audit.tenant': 'Tenant',
  'audit.allTenants': 'All Tenants',
  'audit.actionType': 'Action Type',
  'audit.allActions': 'All Actions',
  'audit.status': 'Status',
  'audit.allStatus': 'All Status',
  'audit.success': 'Success',
  'audit.failed': 'Failed',
  'audit.timeRange': 'Time Range',
  'audit.allTime': 'All Time',
  'audit.today': 'Today',
  'audit.last7days': 'Last 7 days',
  'audit.last30days': 'Last 30 days',
  'audit.keyword': 'Keyword Search',
  'audit.keywordPlaceholder': 'Search user, action, resource...',
  'audit.found': 'Found',
  'audit.records': 'records',
  'audit.clearFilter': 'Clear filters',
  'audit.time': 'Time',
  'audit.user': 'User',
  'audit.action': 'Action',
  'audit.resource': 'Resource',
  'audit.ipAddress': 'IP Address',
  'audit.actions': 'Actions',
  'audit.viewDetail': 'View details',
  'audit.showing': 'Showing',
  'audit.prevPage': 'Previous',
  'audit.nextPage': 'Next',
  'audit.detailTitle': 'Operation Details',
  'audit.logId': 'Log ID',
  'audit.operationTime': 'Operation Time',
  'audit.operationStatus': 'Operation Status',
  'audit.tenantInfo': 'Tenant Info',
  'audit.tenantId': 'Tenant ID',
  'audit.tenantName': 'Tenant Name',
  'audit.operationUser': 'Operation User',
  'audit.userId': 'User ID',
  'audit.userName': 'User Name',
  'audit.operationInfo': 'Operation Info',
  'audit.operationType': 'Operation Type',
  'audit.operationResource': 'Operation Resource',
  'audit.operationDetail': 'Operation Details',
  'audit.networkInfo': 'Network Info',
  'audit.userAgent': 'User Agent',

  // Reports
  'reports.title': 'Reports & Analytics',
  'reports.subtitle': 'Multi-dimensional data analysis and visual reports',
  'reports.last7days': 'Last 7 days',
  'reports.last30days': 'Last 30 days',
  'reports.last90days': 'Last 90 days',
  'reports.apiTrend': 'API Calls Trend',
  'reports.revenueCompare': 'Tenant Revenue Comparison',
  'reports.resourceUsage': 'Resource Usage',
  'reports.userActivity': 'User Activity Trend',
  'reports.activeUsers': 'Active Users',
  'reports.newUsers': 'New Users',
  'reports.tenantSummary': 'Tenant Data Summary',
  'reports.tenantName': 'Tenant Name',
  'reports.apiCalls': 'API Calls',
  'reports.storageUsage': 'Storage Usage',
  'reports.userCount': 'Users',
  'reports.revenue': 'Revenue',
  'reports.quotaUsage': 'Quota Usage',

  // Language Switcher
  'langSwitcher.title': 'Language',

  // Resource Panels
  'res.llm.title': 'AI Models & API',
  'res.llm.subtitle': 'LLM, Embedding, Image Generation, Speech Recognition AI services',
  'res.llm.monthlyCost': 'Monthly Cost',
  'res.llm.usingTenants': 'Using Tenants',
  'res.llm.monthlyTokens': 'Monthly Tokens',
  'res.llm.monthlyCost2': 'Monthly Cost',
  'res.llm.monthlyCalls': 'Monthly Calls',
  'res.llm.tenants': 'Tenants',
  'res.llm.maxContext': 'Max Output',
  'res.llm.model': 'Model',
  'res.llm.configure': 'Configure',
  'res.llm.configTitle': 'Configure',
  'res.llm.apiKey': 'API Key',
  'res.llm.modelName': 'Model Name',
  'res.llm.maxTokens': 'Max Tokens',
  'res.llm.all': 'All',
  'res.llm.imageGen': 'Image Gen',
  'res.llm.speechRecog': 'Speech',
  'res.status.running': 'Running',
  'res.status.maintenance': 'Maintenance',
  'res.status.monitoring': 'Monitoring',
  'res.status.disabled': 'Disabled',
  'res.status.error': 'Error',
  'res.status.enabled': 'enabled',
  'res.email.title': 'Email Service',
  'res.email.subtitle': 'Registration verification, password reset, notification emails',
  'res.email.sender': 'Sender',
  'res.email.dailySent': 'Today Sent',
  'res.email.monthlyTotal': 'Monthly Total',
  'res.email.details': 'Details',
  'res.email.configure': 'Configure',
  'res.email.notConfigured': 'Not configured',
  'res.email.apiKey': 'API Key',
  'res.email.senderEmail': 'Sender Email',
  'res.email.senderName': 'Sender Name',
  'res.email.dailyLimit': 'Daily Limit',
  'res.payment.title': 'Payment Gateway',
  'res.payment.subtitle': 'Subscriptions, one-time payments, refund processing',
  'res.payment.monthlyVolume': 'Monthly Volume',
  'res.payment.tenThousand': 'K',
  'res.payment.successRate': 'Success Rate',
  'res.payment.currencies': 'Currencies',
  'res.payment.configKeys': 'Configure Keys',
  'res.payment.publicKey': 'Public Key / App ID',
  'res.payment.secretKey': 'Secret Key',
  'res.payment.webhookSecret': 'Webhook Secret',
  'res.storage.title': 'Object Storage',
  'res.storage.subtitle': 'User avatars, file uploads, media resource storage',
  'res.storage.usedSpace': 'Used Space',
  'res.storage.totalQuota': 'Total Quota',
  'res.storage.monthlyRequests': 'Monthly Requests',
  'res.storage.usageRate': 'Usage Rate',
  'res.storage.configure': 'Configure',
  'res.sms.title': 'SMS Service',
  'res.sms.subtitle': '2FA, verification codes, notification SMS',
  'res.sms.dailySent': 'Today Sent',
  'res.sms.monthlyTotal': 'Monthly Total',
  'res.sms.dailyQuota': 'Daily Quota',
  'res.sms.configure': 'Configure',
  'res.sms.sendNumber': 'Send Number / Signature',
  'res.sms.dailyLimit': 'Daily Limit',
  'res.monitoring.title': 'Error Monitoring',
  'res.monitoring.subtitle': 'Online exception tracking, performance monitoring, alert notifications',
  'res.monitoring.monthlyErrors': 'Monthly Errors',
  'res.monitoring.monthlyQuota': 'Monthly Quota',
  'res.monitoring.sampleRate': 'Sample Rate',
  'res.monitoring.quotaUsage': 'Quota Usage',
  'res.monitoring.environment': 'Environment',
  'res.monitoring.alertEmail': 'Alert Email',
  'res.monitoring.perfSample': 'Perf. Sampling',
  'res.monitoring.configure': 'Configure',
  'res.monitoring.dsn': 'DSN Address',
  'res.monitoring.env': 'Environment',
  'res.monitoring.errorRate': 'Error Sample Rate (0~1)',
  'res.monitoring.perfRate': 'Perf. Sample Rate (0~1)',
  'res.monitoring.alertAddr': 'Alert Email',
  'res.modal.cancel': 'Cancel',
  'res.modal.saved': 'Saved',
  'res.modal.saveConfig': 'Save Config',
  'res.category.llm': 'AI Model & API',
  'res.category.email': 'Email Service',
  'res.category.payment': 'Payment Gateway',
  'res.category.storage': 'Object Storage',
  'res.category.sms': 'SMS Service',
  'res.category.monitoring': 'Error Monitoring',
  'res.category.workers': 'Background Workers',
  'res.workers.title': 'Background Workers',
  'res.workers.subtitle': 'Monitor and manage background schedulers, compressors, and services',
  'res.workers.categoryDesc': 'Notifications / Proactive / Compression / Tasks',
  'res.workers.onlineUsers': 'Online Users',
  'res.workers.stopped': 'Stopped',
  'res.workers.interval': 'Interval',
  'res.workers.uptime': 'Uptime',
  'res.workers.lastScan': 'Last Scan',
  'res.workers.scanDuration': 'Scan Duration',
  'res.workers.todayScans': 'Today Scans',
  'res.workers.todayDelivered': 'Today Delivered',
  'res.workers.todayFailed': 'Today Failed',
  'res.workers.totalDelivered': 'Total Delivered',
  'res.workers.totalFailed': 'Total Failed',
  'res.workers.totalScans': 'Total Scans',
  'res.workers.userBreakdown': 'Per-User Breakdown',
  'res.workers.userId': 'User ID',
  'res.workers.cumulativeDelivered': 'Cumulative Delivered',
  'res.workers.cumulativeFailed': 'Cumulative Failed',
  'res.workers.estTokens': 'Est. Tokens',
  'res.workers.estCost': 'Est. Cost',
  'res.workers.skipped': 'Skipped (below threshold)',
  'res.workers.lastCompressedSession': 'Last Compressed Session',

  // Resource category descriptions
  'res.category.speech': 'Speech Service',
  'res.category.llmDesc': 'LLM / Embedding / VLM / OCR / Image Gen / Doc Parse',
  'res.category.speechDesc': 'ASR / TTS / File Transcription / Multimodal',
  'res.category.emailDesc': 'Tencent Cloud SES / SendGrid / AWS SES',
  'res.category.storageDesc': 'Alibaba Cloud OSS',

  // Status badges
  'res.status.pendingConfig': 'Pending Config',
  'res.status.pendingKey': 'Pending Key',
  'res.status.stopped': 'Stopped',

  // AddConfig modal
  'res.addConfig.title': 'Add Configuration',
  'res.addConfig.category': 'Category',
  'res.addConfig.configKey': 'Config Key',
  'res.addConfig.displayName': 'Display Name',
  'res.addConfig.valueType': 'Value Type',
  'res.addConfig.value': 'Value',
  'res.addConfig.valuePlaceholder': 'Configuration value',
  'res.addConfig.description': 'Description',
  'res.addConfig.descriptionPlaceholder': 'Optional description',
  'res.addConfig.secretLabel': 'Secret value (masked in API responses)',
  'res.addConfig.requiredError': 'Config Key and Display Name are required',
  'res.addConfig.createFailed': 'Failed to create config',
  'res.addConfig.saving': 'Saving...',

  // Modal common
  'res.modal.saving': 'Saving...',
  'res.modal.leaveEmptyNoChange': 'Leave empty to keep current value',
  'res.modal.leaveEmptyHint': 'Leave empty to keep current value',
  'res.modal.pleaseInput': 'Please enter...',

  // Email panel
  'res.email.tencentSES': 'Tencent Cloud SES',
  'res.email.regionChina': 'Mainland China',
  'res.email.featureVerify': 'Registration',
  'res.email.featureReset': 'Password Reset',
  'res.email.featureNotify': 'Notifications',
  'res.email.loading': 'Loading email config...',
  'res.email.configSmtp': 'Configure Tencent Cloud SES SMTP',

  // SMS panel
  'res.sms.secretPlaceholder': 'Enter secret key',

  // Speech panel
  'res.speech.title': 'Speech Service Config',
  'res.speech.subtitle': 'Manage ASR speech recognition and TTS speech synthesis services',
  'res.speech.enabled': 'Enabled',
  'res.speech.monthlyCalls': 'Monthly Calls',
  'res.speech.cost': 'Cost',
  'res.speech.loading': 'Loading speech service config...',
  'res.speech.noConfig': 'No speech service configured',
  'res.speech.noConfigHint': 'Please run seed to initialize speech service config',
  'res.speech.noApiKey': 'API Key not set',
  'res.speech.callsUnit': 'calls',
  'res.speech.monthlyCost': 'Monthly Cost',
  'res.speech.model': 'Model',
  'res.speech.unitPrice': 'Unit Price',
  'res.speech.configure': 'Configure',
  'res.speech.voice': 'Voice',
  'res.speech.format': 'Output Format',
  'res.speech.workspaceId': 'Workspace ID',
  'res.speech.appId': 'App ID',
  'res.speech.upstreamSampleRate': 'Upstream Sample Rate',
  'res.speech.downstreamSampleRate': 'Downstream Sample Rate',
  'res.speech.asrLabel': 'ASR Real-time Recognition',
  'res.speech.ttsLabel': 'TTS Real-time Synthesis',
  'res.speech.asrFileLabel': 'File Transcription',
  'res.speech.voiceCallLabel': 'Multimodal Interaction',
  'res.speech.pricePerHour': 'CNY/hour',
  'res.speech.pricePerKCalls': 'CNY/K calls',
  'res.speech.pricePerMinute': 'CNY/minute',
  'res.speech.featureRealtime': 'Real-time Streaming',
  'res.speech.featureMultilang': 'Multi-language',
  'res.speech.featureMultiVoice': 'Multi-voice',
  'res.speech.featureOffline': 'Offline Transcription',
  'res.speech.featureLongAudio': 'Long Audio',
  'res.speech.featureDuplex': 'Full Duplex',
  'res.speech.featureInterrupt': 'Voice Interrupt',
  'res.speech.featureMemory': 'Memory Injection',

  // Storage panel
  'res.storage.loading': 'Loading storage config...',
  'res.storage.noConfig': 'No storage service configured',
  'res.storage.noConfigHint': 'Please run seed to initialize storage config',
  'res.storage.aliOSS': 'Alibaba Cloud OSS',
  'res.storage.tencentCOS': 'Tencent Cloud COS',
  'res.storage.requestsUnit': 'requests',
  'res.storage.monthlyCost': 'Monthly Cost',
  'res.storage.notSet': 'Not set',
  'res.storage.cdnDomain': 'CDN Domain',
  'res.storage.signExpiry': 'Signed URL Expiry',
  'res.storage.signExpiryLabel': 'Signed URL Expiry (seconds)',
  'res.storage.featureObjStorage': 'Object Storage',
  'res.storage.featureSignedUrl': 'Signed URL',
  'res.storage.featureLifecycle': 'Lifecycle',
  'res.storage.featureS3Compat': 'S3 Compatible',
  'res.storage.featureCDN': 'CDN Acceleration',
  'res.storage.cdnPlaceholder': 'Optional, e.g. https://cdn.example.com',

  // LLM panel extra
  'res.llm.vlm': 'Vision',
  'res.llm.docParse': 'Doc Parse',
  'res.llm.ocrAlicloud': 'ReadDoc OCR',
  'res.llm.ocrRecog': 'OCR Recognition',
  'res.llm.noAccessKey': 'AccessKey not configured',
  'res.llm.noApiKey': 'API Key not set',
  'res.llm.monthlyGenerated': 'Monthly Generated',
  'res.llm.imagesUnit': 'images',
  'res.llm.defaultSize': 'Default Size',
  'res.llm.unitPrice': 'Unit Price',
  'res.llm.perImage': 'image',
  'res.llm.callsUnit': 'calls',
  'res.llm.inputPrice': 'Input Price',
  'res.llm.outputPrice': 'Output Price',
  'res.llm.vectorDim': 'Vector Dimension',
  'res.llm.loading': 'Loading AI services...',
  'res.llm.apiEndpoint': 'API Endpoint',
  'res.llm.name': 'Name',
  'res.llm.feat.semanticSearch': 'Semantic Search',
  'res.llm.feat.longTermMemory': 'Long-term Memory',
  'res.llm.feat.vectorRetrieval': 'Vector Retrieval',
  'res.llm.feat.imageUnderstanding': 'Image Understanding',
  'res.llm.feat.sceneRecog': 'Scene Recognition',
  'res.llm.feat.multiTurn': 'Multi-turn Chat',
  'res.llm.feat.text2img': 'Text to Image',
  'res.llm.feat.multiSize': 'Multi-size',
  'res.llm.feat.hdGen': 'HD Generation',
  'res.llm.feat.pdfParse': 'PDF Parse',
  'res.llm.feat.longDocQA': 'Long Doc QA',
  'res.llm.feat.tableExtract': 'Table Extraction',
  'res.llm.feat.textRecog': 'Text Recognition',
  'res.llm.feat.multiLang': 'Multi-language',
  'res.llm.feat.handwriting': 'Handwriting',
  'res.llm.feat.chat': 'Chat',
  'res.llm.feat.codeGen': 'Code Generation',
  'res.llm.feat.textAnalysis': 'Text Analysis',

  // Dashboard mock
  'dashboard.month.oct': 'Oct',
  'dashboard.month.nov': 'Nov',
  'dashboard.month.dec': 'Dec',
  'dashboard.month.jan': 'Jan',
  'dashboard.month.feb': 'Feb',
  'dashboard.month.mar': 'Mar',
  'dashboard.plan.enterprise': 'Enterprise',
  'dashboard.plan.professional': 'Professional',
  'dashboard.plan.basic': 'Basic',
  'dashboard.plan.free': 'Free',
  'dashboard.action.createTenant': 'Create Tenant',
  'dashboard.action.createTenantDesc': 'Add new tenant account',
  'dashboard.action.userMgmt': 'User Management',
  'dashboard.action.userMgmtDesc': 'Manage users and permissions',
  'dashboard.action.resourceConfig': 'Resource Config',
  'dashboard.action.resourceConfigDesc': 'Configure system resources',
  'dashboard.action.auditLog': 'Audit Logs',
  'dashboard.action.auditLogDesc': 'View system logs',

  // Waitlist
  'waitlist.title': 'Waitlist',
  'waitlist.subtitle': 'Manage beta application users',
  'waitlist.confirmDelete': 'Are you sure to delete?',
  'waitlist.pending': 'Pending',
  'waitlist.totalApplications': 'Total Applications',
  'waitlist.filter.all': 'All',
  'waitlist.filter.pending': 'Pending',
  'waitlist.filter.approved': 'Approved',
  'waitlist.filter.invited': 'Invited',
  'waitlist.filter.rejected': 'Rejected',
  'waitlist.loading': 'Loading...',
  'waitlist.noData': 'No data',
  'waitlist.col.email': 'Email',
  'waitlist.col.source': 'Source',
  'waitlist.col.status': 'Status',
  'waitlist.col.applyTime': 'Apply Time',
  'waitlist.col.actions': 'Actions',
  'waitlist.status.pending': 'Pending',
  'waitlist.status.approved': 'Approved',
  'waitlist.status.rejected': 'Rejected',
  'waitlist.status.invited': 'Invited',
  'waitlist.approve': 'Approve',
  'waitlist.reject': 'Reject',
  'waitlist.sendInvite': 'Send Invite',
  'waitlist.delete': 'Delete',

  // Plans
  'plans.title': 'Plan Management',
  'plans.subtitle': 'Manage subscription plans, quotas and pricing strategies',
  'plans.createPlan': 'New Plan',
  'plans.editPlanTitle': 'Edit Plan - {{name}}',
  'plans.planCode': 'Plan Code',
  'plans.planCodePlaceholder': 'e.g. free, pro, plus',
  'plans.planName': 'Plan Name',
  'plans.planNamePlaceholder': 'e.g. Free Plan',
  'plans.pricing': 'Pricing',
  'plans.monthlyPriceCents': 'Monthly Price (cents)',
  'plans.perMonth': 'mo',
  'plans.allowPaidSkill': 'Allow Paid Skills',
  'plans.quotaSettings': 'Quota Settings',
  'plans.tokenQuota': 'Token Quota / Month',
  'plans.requestQuota': 'Request Quota / Month',
  'plans.skillCallQuota': 'Skill Calls / Month',
  'plans.fileQuota': 'File Quota / Month',
  'plans.storageQuota': 'Storage (MB)',
  'plans.cancel': 'Cancel',
  'plans.saving': 'Saving...',
  'plans.save': 'Save',
  'plans.loading': 'Loading...',
  'plans.planCount': 'Plans',
  'plans.totalSubscribers': 'Total Subscribers',
  'plans.monthlyRequests': 'Monthly Requests',
  'plans.monthlyTokenUsage': 'Monthly Token Usage',
  'plans.free': 'Free',
  'plans.currentSubs': 'Current Subscribers',
  'plans.subsCount': '{{count}} users',
  'plans.tokenQuotaLabel': 'Token Quota',
  'plans.requestQuotaLabel': 'Requests',
  'plans.skillCallLabel': 'Skill Calls',
  'plans.fileQuotaLabel': 'Files',
  'plans.storageLabel': 'Storage',
  'plans.paidSkillLabel': 'Paid Skills',
  'plans.enabled': 'Enabled',
  'plans.disabled': 'Disabled',
  'plans.edit': 'Edit',
  'plans.delete': 'Delete',
  'plans.cannotDeleteWithSubs': 'Cannot delete a plan with active subscribers',
  'plans.confirmDelete': 'Are you sure to delete this plan?',
  'plans.monthlyUsageStats': 'Monthly Platform Usage Statistics',
  'plans.metric': 'Metric',
  'plans.value': 'Value',
  'plans.totalRequests': 'Total Requests',
  'plans.tokenInput': 'Token Input',
  'plans.tokenOutput': 'Token Output',
  'plans.tokenTotal': 'Token Total',

  // Registration Settings
  'settings.registration.mode': 'Registration Mode',
  'settings.registration.modeDesc': 'Choose how users register. Open registration allows anyone to sign up; invite-only requires a valid invite code.',
  'settings.registration.open': 'Open Registration',
  'settings.registration.openDesc': 'Anyone can register',
  'settings.registration.invite': 'Invite Only',
  'settings.registration.inviteDesc': 'Requires invite code',
  'settings.registration.cancel': 'Cancel',
  'settings.registration.saving': 'Saving...',
  'settings.registration.saved': 'Saved',
  'settings.registration.saveSettings': 'Save Settings',
  'settings.registration.totalGenerated': 'Total Generated',
  'settings.registration.totalUsed': 'Total Used',
  'settings.registration.activeCodes': 'Active Codes',
  'settings.registration.generateTitle': 'Generate Invite Codes',
  'settings.registration.generateCount': 'Count',
  'settings.registration.maxUses': 'Uses Per Code',
  'settings.registration.times': '{{count}} times',
  'settings.registration.unlimited': 'Unlimited',
  'settings.registration.inviteQuota': 'New User Invite Quota',
  'settings.registration.quotaZero': '0 (cannot invite others)',
  'settings.registration.quotaSlots': '{{count}} invite slots',
  'settings.registration.expiry': 'Validity Period',
  'settings.registration.days': '{{count}} days',
  'settings.registration.neverExpire': 'Never expire',
  'settings.registration.noteOptional': 'Note (optional)',
  'settings.registration.notePlaceholder': 'e.g. Beta user batch 1',
  'settings.registration.generating': 'Generating...',
  'settings.registration.generateBtn': 'Generate Codes',
  'settings.registration.inviteList': 'Invite Code List',
  'settings.registration.noInvites': 'No invite codes yet',
  'settings.registration.colCode': 'Invite Code',
  'settings.registration.colStatus': 'Status',
  'settings.registration.colUsage': 'Usage',
  'settings.registration.colExpiry': 'Expires',
  'settings.registration.colNote': 'Note',
  'settings.registration.colCreated': 'Created',
  'settings.registration.colActions': 'Actions',
  'settings.registration.copy': 'Copy',
  'settings.registration.deactivate': 'Deactivate',
  'settings.registration.statusActive': 'Active',
  'settings.registration.statusUsed': 'Used Up',
  'settings.registration.statusExpired': 'Expired',
  'settings.registration.statusInactive': 'Deactivated',

  // Points Settings
  'settings.points.rulesTitle': 'Points Rules Configuration',
  'settings.points.noConfigs': 'No points configuration',
  'settings.points.noConfigsHint': 'Add configs with category=points in system settings',
  'settings.points.cancel': 'Cancel',
  'settings.points.saving': 'Saving...',
  'settings.points.saved': 'Saved',
  'settings.points.saveSettings': 'Save Settings',
  'settings.points.loadError': 'Failed to load points configuration',
  'settings.points.saveError': 'Save failed',
  'settings.points.searchError': 'Failed to search users',
  'settings.points.operationFailed': 'Operation failed',
  'settings.points.adminGrant': 'Admin grant',
  'settings.points.adminDeduct': 'Admin deduct',
  'settings.points.grantSuccess': 'Successfully granted {{amount}} points to {{user}}',
  'settings.points.deductSuccess': 'Successfully deducted {{amount}} points from {{user}}',
  'settings.points.itemUpdated': 'Item updated',
  'settings.points.itemCreated': 'Item created',
  'settings.points.confirmDelete': 'Confirm removing "{{name}}"?',
  'settings.points.grantDeductTitle': 'Grant / Deduct Points',
  'settings.points.searchUser': 'Search User',
  'settings.points.searchPlaceholder': 'Search by email or name...',
  'settings.points.searchBtn': 'Search',
  'settings.points.amount': 'Points Amount',
  'settings.points.amountPlaceholder': 'Enter points amount',
  'settings.points.description': 'Description',
  'settings.points.descriptionPlaceholder': 'Description (optional)',
  'settings.points.grant': 'Grant',
  'settings.points.deduct': 'Deduct',
  'settings.points.exchangeTitle': 'Points Exchange Items',
  'settings.points.addItem': 'Add Item',
  'settings.points.editItem': 'Edit Item',
  'settings.points.itemName': 'Item Name',
  'settings.points.itemNamePlaceholder': 'e.g. Invite Quota x5',
  'settings.points.itemType': 'Type',
  'settings.points.costPoints': 'Cost Points',
  'settings.points.stock': 'Stock (0=unlimited)',
  'settings.points.icon': 'Icon (Remix Icon)',
  'settings.points.sortOrder': 'Sort Order',
  'settings.points.quotaAmount': 'Quota Amount',
  'settings.points.itemDesc': 'Description',
  'settings.points.itemDescPlaceholder': 'Item description (optional)',
  'settings.points.update': 'Update',
  'settings.points.create': 'Create',
  'settings.points.noItems': 'No exchange items',
  'settings.points.colItem': 'Item',
  'settings.points.colType': 'Type',
  'settings.points.colPoints': 'Points',
  'settings.points.colStockSold': 'Stock/Sold',
  'settings.points.colStatus': 'Status',
  'settings.points.colActions': 'Actions',
  'settings.points.unlimited': 'Unlimited',
  'settings.points.edit': 'Edit',
  'settings.points.remove': 'Remove',
  'settings.points.typeInviteQuota': 'Invite Quota',
  'settings.points.typeTokenPack': 'Token Pack',
  'settings.points.typePlanTime': 'Plan Duration',
  'settings.points.typeSkillUnlock': 'Skill Unlock',
  'settings.points.typeCustom': 'Custom',
  'settings.points.registerBonus': 'Registration Bonus',
  'settings.points.dailyLogin': 'Daily Login Reward',
  'settings.points.inviteReward': 'Invite Reward',
  'settings.points.inviteeBonus': 'Invitee Bonus',
  'settings.points.messageCost': 'Message Cost',
  'settings.points.voiceCost': 'Voice Message Cost',
  'settings.points.skillCallCost': 'Skill Call Cost',
  'settings.points.fileUploadCost': 'File Upload Cost',
  'settings.points.enabled': 'Points System Enabled',
  'settings.points.dailyFreeMessages': 'Daily Free Messages',
  'settings.points.initialBalance': 'Initial Balance',

  // Billing (additional)
  'billing.noPlans': 'No plans configured yet',
  'billing.tokenQuotaMonth': 'Token Quota / Month',
  'billing.tokenQuota': 'Token Quota',
  'billing.paidSkills': 'Paid Skills',
  'billing.yes': 'Yes',
  'billing.no': 'No',

  // Service Configs (Settings tab - additional)
  'settings.services.title': 'Service Configs',
  'settings.services.subtitle': 'Manage AI models, third-party API keys, and external service integrations',
  'settings.services.refresh': 'Refresh',
  'settings.services.itemCount': '{{count}} items',
  'settings.services.notConfigured': 'Not configured',
  'settings.services.secret': 'Secret',
  'settings.services.inactive': 'Inactive',
  'settings.services.enterValue': 'Enter value...',
  'settings.services.save': 'Save',
  'settings.services.cancel': 'Cancel',
  'settings.services.saved': 'Saved',
  'settings.services.empty': 'empty',
  'settings.services.editTitle': 'Edit',
  'settings.services.disable': 'Disable',
  'settings.services.enable': 'Enable',
  'settings.services.noConfigs': 'No configs found',
  'settings.services.catLlm': 'LLM / AI Model',
  'settings.services.catEmbedding': 'Embedding',
  'settings.services.catVision': 'Vision (VLM)',
  'settings.services.catImageGen': 'Image Generation',
  'settings.services.catDocParse': 'Document Parsing',
  'settings.services.catSpeech': 'Speech (ASR/TTS)',
  'settings.services.catEmail': 'Email',
  'settings.services.catStorage': 'Storage',
  'settings.services.catPayment': 'Payment',
  'settings.services.catSms': 'SMS',
  'settings.services.catOcr': 'OCR',
  'settings.services.catMonitor': 'Monitoring',
};
